<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addService, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="service" :title="$t('front.import_modal', {model: $t('strings.service')})")
    modal-services(:newRecord='newRecord', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.services') }}:
            span {{ $t('strings.description', {attribute: $t('strings.services')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected"  max-height="350px" :data="services")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                div
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('services.'+ item)")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('services.date')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.date")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                          vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('services.service_type')" v-model="filters.whereIn.service_type_id")
                          vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in service_type")
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(url="customers" columns="tradename,etc" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                              vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in servicesCatalog.customers")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('services.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'folio'")  {{data[indextr][column]}}
                  slot(v-if="column == 'payment_folio'")  {{data[indextr]['payments'].length > 0 ? data[indextr]['payments'][0]['folio'] : 'En espera de pago...'}}
                  slot(v-if="column == 'profile_id'")  {{ `${data[indextr]['profile']['name']} ${data[indextr]['profile']['last_name']}` }}
                  slot(v-if="column == 'hp_profile_id'")  {{ `${data[indextr]['hp_profile']['name']} ${data[indextr]['hp_profile']['last_name']}` }}
                  slot(v-if="column == 'service_amount'") {{data[indextr]['service_amount'] | currency }}
                  slot(v-if="column == 'expert_commission'") {{data[indextr]['expert_commission'] | currency }}
                  slot(v-if="column == 'conekta_commission'") {{data[indextr]['conekta_commission'] | currency }}
                  slot(v-if="column == 'twilio_commission'") {{data[indextr]['twilio_commission'] | currency }}
                  slot(v-if="column == 'formula_constant'") {{data[indextr]['formula_constant_commission'] | currency }}
                  slot(v-if="column == 'amount'")  {{data[indextr]['total_amount'] | currency }}
                  slot(v-if="column == 'payment_method'")  {{data[indextr]['payment_method_display'] }}
                  slot(v-if="column == 'service_type'")  {{data[indextr]['service_type_display'] }}
                  vm-status-indicator(v-if="column == 'status'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                  slot(v-if="column == 'date'")  {{data[indextr]['created_at']}}
                vm-td
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ModalServices from '@/components/modals/ModalServices.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Services')

export default {
  name: 'Services',
  components: {
    ModalServices,
    ModalImport
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    newRecord: {},
    selected: [],
    columns: [
      'folio',
      'profile_id',
      'hp_profile_id',
      'service_amount',
      'expert_commission',
      'conekta_commission',
      'twilio_commission',
      'formula_constant',
      'amount',
      'payment_method',
      'service_type',
      'status',
      'date'
    ],
    columnsOrderBy: [
      // Nota solo si las columnas son atributos
    ],
    status: [
      // Agregar los estatus si maneja
      {
        text: 'En proceso',
        value: 'in_progress',
        color: 'primary'
      },
      {
        text: 'Completado',
        value: 'completed',
        color: 'success'
      },
      {
        text: 'Cancelado',
        value: 'canceled',
        color: 'danger'
      }
    ],
    service_type: [
      {
        text: 'Comunicación via chat',
        value: '1',
        color: 'primary'
      },
      {
        text: 'Comunicación via llamada',
        value: '2',
        color: 'success'
      },
      {
        text: 'Agendar Consulta',
        value: '3',
        color: 'dark'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        // Agregar las columnas que se filtraran en el buscador
        // name_last_name: [
        //  'name',
        //  'last_name'
        // ],
        service_type: {
          name: ''
        },
        hp_profile: {
          name: '',
          'specialisms.name': ''
        },
        profile: {
          name: ''
        },
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
        status: [],
        service_type_id: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at:
        date: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  computed: {
    ...mapGetters([
      'services',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('services.' + column)}` : `${str} ${t.$t('services.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.service'), columns: concatColumns, column: this.$t('services.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getServices(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getServices(this.currentPage)
    }
  },
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    await this.getServices(1)
    await this.loadServicesCatalog()
  },
  methods: {
    ...mapActions([
      'deleteService',
      'deleteServices',
      'loadServices',
      'loadCatalog',
      'loadServicesCatalog',
      'actionService',
      'setModalImportVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    colorStatus (code) {
      switch (code) {
        case 'completed':
          return 'success'
        case 'in_progress':
          return 'primary'
        case 'canceled':
          return 'danger'
      }
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.services.findIndex(u => u.id === this.selected[0].id)
      this.editService(this.selected[0], idx)
    },
    addService () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    editService (service, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.newRecord = { ...service }
    },
    async deleteServiceConfirm (service) {
      let t = this
      this.auxDeleteService = () => {
        t.deleteService(service).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.service'), attribute: this.$t(service.folio) }),
        accept: this.auxDeleteService
      })
    },
    async deleteServicesConfirm () {
      let t = this
      let servicesMany = parseDeleteMany(this.selected, 'folio')
      this.auxDeleteService = () => {
        t.deleteServices(servicesMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.service'), attribute: servicesMany.values }),
        accept: this.auxDeleteService
      })
    },
    async setActionService (record, action) {
      record.id && this.actionService({ id: record.id, action })
    },
    async getServices (page) {
      let t = this
      this.loadServices({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let service = this.services.filter(service => service.id === parseInt(index))[0]
      service && this.editService(service, index)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      this.filters.betweenDates.date = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  float: left;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
